var _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgThingsDashboard = function SvgThingsDashboard(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 56,
    height: 64,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#D6DEE0",
    d: "M55.426 16v32L27.713 64 0 48V16L27.713 0zM5.328 19.076v25.848l22.385 12.924 22.385-12.924V19.076L27.713 6.152z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#D6DEE0"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m24.368 28.916 5.323-3.025v24.35l-2.676 1.512-2.647-1.513zM38.797 19.026l-5.324-3.055v31.971l5.324-3.025zM15.262 37.295l5.295-3.055v13.702l-5.295-3.025z"
  }))));
};
export { SvgThingsDashboard as ReactComponent };
export default __webpack_public_path__ + "f94fa5b98482593b97283e4b582d9f6b.svg";